import type { GuardianPayload, SubjectPayload } from './Order.types';

import type {
  FamilyHistory,
  PatientOrderingEligibilityResponse,
  PatientOrderingPaymentIntent,
  PatientOrderingPricing,
  ProductDataCAD,
} from '@customTypes';

export const OrderActions = {
  SET_CAMPAIGN_CODE: 'SET_CAMPAIGN_CODE',
  SET_SUBJECT: 'SET_SUBJECT',
  SET_GUARDIAN: 'SET_GUARDIAN',
  MERGE_SUBJECT: 'MERGE_SUBJECT',
  SET_FAMILY_HISTORY: 'SET_FAMILY_HISTORY',
  MERGE_FAMILY_HISTORY: 'MERGE_FAMILY_HISTORY',
  SET_PRODUCT_INFORMATION: 'SET_PRODUCT_INFORMATION',
  MERGE_PRODUCT_INFORMATION: 'MERGE_PRODUCT_INFORMATION',
  SET_CONSENTS_GRANTED: 'SET_CONSENTS_GRANTED',
  ADD_CONSENT: 'ADD_CONSENT',
  SET_EXTERNAL_MEMBER_ID: 'SET_EXTERNAL_MEMBER_ID',
  PRODUCT_SELECTED: 'PRODUCT_SELECTED',
  PRODUCT_DESELECTED: 'PRODUCT_DESELECTED',

  ELIGIBILITY_RESET: 'eligibility/RESET',
  ELIGIBILITY_UPDATED: 'eligibility/UPDATED',

  PAYMENT_INTENT_CREATED: 'paymentIntent/CREATED',
  PAYMENT_INTENT_UPDATED: 'paymentIntent/UPDATED',

  PRICING_FETCHED: 'pricing/FETCHED',

  RESET: 'RESET',
  SET_IS_REREQUISITION: 'SET_IS_REREQUISITION',
} as const;

export type OrderActionType =
  | { type: typeof OrderActions.SET_CAMPAIGN_CODE; value?: string }
  | { type: typeof OrderActions.SET_EXTERNAL_MEMBER_ID; value?: string }
  | { type: typeof OrderActions.SET_SUBJECT; value: SubjectPayload }
  | { type: typeof OrderActions.SET_GUARDIAN; value: GuardianPayload | null }
  | { type: typeof OrderActions.MERGE_SUBJECT; value: Partial<SubjectPayload> }
  | { type: typeof OrderActions.SET_FAMILY_HISTORY; value: FamilyHistory }
  | { type: typeof OrderActions.MERGE_FAMILY_HISTORY; value: Partial<FamilyHistory> }
  | { type: typeof OrderActions.SET_PRODUCT_INFORMATION; value?: ProductDataCAD }
  | { type: typeof OrderActions.MERGE_PRODUCT_INFORMATION; value: Partial<ProductDataCAD> }
  | { type: typeof OrderActions.SET_CONSENTS_GRANTED; value: string[] }
  | { type: typeof OrderActions.ADD_CONSENT; value: string }
  // Product selection
  | { type: typeof OrderActions.PRODUCT_SELECTED; value: string }
  | { type: typeof OrderActions.PRODUCT_DESELECTED; value: string }
  // Eligibility actions
  | { type: typeof OrderActions.ELIGIBILITY_RESET }
  | { type: typeof OrderActions.ELIGIBILITY_UPDATED; value: PatientOrderingEligibilityResponse }
  // Payment Iintent
  | { type: typeof OrderActions.PAYMENT_INTENT_CREATED; value: PatientOrderingPaymentIntent }
  | { type: typeof OrderActions.PAYMENT_INTENT_UPDATED; value: PatientOrderingPaymentIntent }
  // Pricing
  | { type: typeof OrderActions.PRICING_FETCHED; value: PatientOrderingPricing }
  | { type: typeof OrderActions.RESET }
  | { type: typeof OrderActions.SET_IS_REREQUISITION; value: boolean };
